import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Select from '../../../../../../commons/Select/Select';
import { ButtonColor, ButtonSize } from '../../../../../../designSystem/Button/Button.types';
import Button from '../../../../../../designSystem/Button/Button';
import { SelectOption } from '../../../../../../commons/Select/Select.types';
import RSelect from 'react-select/dist/declarations/src/Select';
import { getCompaniesDomainsFilterSchema } from './CompaniesDomainsFilterModal.schema';
import { CompaniesDomainsFilterModalSchema } from './CompaniesDomainsFilterModal.types';
import { companiesDomainsFilterData } from './CompaniesDomainsFilterModal.data';
import { ModalProps, ModalSizes } from '../../../../../../commons/Modal/Modal.types';
import Modal from '../../../../../../commons/Modal/Modal';
import { useActiveNafList } from '../../../../../../../hooks/fetchers/useActiveNafList/useActiveNafList';
import { SearchCompaniesOnMapContext } from '../../../SearchCompaniesOnMap/SearchCompaniesOnMap.context';
// import Form from '../../../../../../commons/Form/Form';

export default (props: ModalProps) => {

  const { filters, setFilters } = useContext(SearchCompaniesOnMapContext);

  const { data: NAFList } = useActiveNafList();

  const domainsSelectRef = useRef<RSelect>();

  const [inputValue, setInputValue] = useState<string>()

  const formProps = useForm<CompaniesDomainsFilterModalSchema>({
    resolver: yupResolver(getCompaniesDomainsFilterSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { isValid, errors }
  } = formProps;

  const domains = useWatch({
    control,
    name: 'domains',
  });

  useEffect(() => {
    // console.log('domains', filters.domains)
    if (filters.domains) {
      setValue('domains', filters.domains, { shouldValidate: true });
      // domainsSelectRef.current?.setValue(filters.domains, 'select-option')
    }
  }, [filters]);

  const isResetable = useMemo(
    () => Boolean(domains && domains.length > 0),
    [domains]
  );

  const onReinitialize = () => {
    domainsSelectRef.current?.clearValue()
    setFilters((state) => ({
      ...state,
      domains: []
    }));
    // closeModal()
  };

  const onSubmit = handleSubmit(({ domains }) => {
    setFilters((state) => ({
      ...state,
      domains: (domains as string[]) || []
    }));
    props.setOpen(false)
  });

  const updatedFormData = useMemo(
    () =>
      companiesDomainsFilterData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            case 'domains':
              return {
                ...item,
                options: NAFList
                  ?.filter((item) => item.description.toLowerCase().includes(inputValue?.toLowerCase() || 'Not in list'))
                  ?.map(({ NAF_code, description }) => ({
                    label: description,
                    value: NAF_code.toString(),
                  })),
                defaultValue: filters.domains.map(value => ({
                  value,
                  label: NAFList?.find((item) => item.NAF_code === parseInt(value))?.description
                }))
              };
            default:
              return item;
          }
        })
      ),
    [NAFList, inputValue, filters]
  );

  return (
    <Modal size={ModalSizes.Small} closeOnClickOutside {...props}>
      {/* <Form<CompaniesDomainsFilterModalSchema> 
        // @ts-ignore
        data={updatedFormData}
        {...{ formProps, onSubmit }}
        afterInputsElement={isResetable && (
          <Button
            style={{ alignSelf: 'unset' }}
            onClick={(e) => {
              e.preventDefault();
              onReinitialize();
            }}
            size={ButtonSize.Large}
            color={ButtonColor.Contrast}>
            Réinitialiser
          </Button>
        )}
      /> */}
      <form className="form" style={{ width: 'calc(100% - var(--spacing-mToL) * 2)' }}>
        {updatedFormData.map((row, rowIndex) => (
          <div key={`row#${rowIndex}`} className="form__row">
            {row.map(({ name, label, options, ...props }) => (
              <Controller
                key={`controlledInput#${rowIndex}`}
                name={name}
                render={({ field: { onChange }, ...rest }) => (
                  <Select
                    // @ts-ignore
                    ref={(ref) => (domainsSelectRef.current = ref)}
                    error={errors[name]?.message as string}
                    onInputChange={(value: string) => setInputValue(value)}
                    {...{ label, options, ...rest }}
                    {...props}
                    // @ts-ignore
                    onChange={(arr: SelectOption | SelectOption[]) => {
                      const values = (arr as SelectOption[]).map((item) => {
                        if (typeof item === 'string') {
                          return item;
                        } else {
                          return item.value;
                        }
                      });
                      onChange(values);
                    }}
                    // @ts-ignore
                    noOptionsMessage={({ inputValue }) => !inputValue ? 'Chercher un domaine' : 'Aucun résultat trouvé'}
                    isMulti
                  />
                )}
                {...{ control }}
              />
            ))}
          </div>
        ))}
        {isResetable && (
          <Button
            style={{ alignSelf: 'unset' }}
            onClick={(e) => {
              e.preventDefault();
              onReinitialize();
            }}
            size={ButtonSize.Large}
            color={ButtonColor.Contrast}>
            Réinitialiser
          </Button>
        )}
        <Button
          style={{ alignSelf: 'unset' }}
          onClick={(e) => {
            e.preventDefault();
            // setPaymentModalOpen(true);
            onSubmit();
          }}
          size={ButtonSize.Large}
          disabled={!isValid}>
          Appliquer
        </Button>
      </form>
    </Modal>
  );
};
